import { render } from "./ForgotUsername.vue?vue&type=template&id=3604f686&scoped=true"
import script from "./ForgotUsername.vue?vue&type=script&lang=js"
export * from "./ForgotUsername.vue?vue&type=script&lang=js"

import "./ForgotUsername.vue?vue&type=style&index=0&id=3604f686&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3604f686"]])

export default __exports__